module.exports = "<h2> Simple Modal </h2>\n<div class=\"\">\n  <button type=\"button\" class=\"btn btn-info navbar-btn w-100\" (click)=\"closeDialog()\">\n    <span>Close Dialog</span>\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/modal/modal.component.html
// module id = ../../../../../src/app/shared/components/modal/modal.component.html
// module chunks = main